import { render, staticRenderFns } from "./HmGameHorizontal.vue?vue&type=template&id=fd81c6ea"
import script from "./HmGameHorizontal.vue?vue&type=script&lang=js"
export * from "./HmGameHorizontal.vue?vue&type=script&lang=js"
import style0 from "./HmGameHorizontal.vue?vue&type=style&index=0&id=fd81c6ea&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports